import { ProjectService } from '../../shared/services/project.service';
import { Component, OnDestroy, OnInit ,AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { Subscription } from 'rxjs/Rx';
import { NgStyle } from "@angular/common";
import { StorageService } from '../../shared/services/storage.service';
import { SlicePipe } from '@angular/common/src/pipes';


@Component({
  selector: 'appc-project-profile',
  templateUrl: './project-profile.component.html',
  styleUrls: ['./project-profile.component.scss']
})
export class ProjectProfileComponent implements OnInit, OnDestroy ,AfterViewInit{


  title:String;
  list:string;
  descriptiondata:string;
  lessdata:boolean=false;
  moredata:boolean=true;
  descriptionlength:number;
 

  subscription: Subscription;
  coverBackground: String;
  profileBackground: String;
  profilePic: String;
  projectPic: String;
  project: FirebaseObjectObservable<any>;
  public zoom: number;
  public center: any;
  public lat: any;
  public long: any;
  address:any;
  complete: any;
  iconUrl: string;
  public markerPosition = [];
  public errorMessage: string;
  public infoposition: boolean = true;
  public marker = {
    display: true,
    lat: null,
    lng: null,
    content: '',
    name:'',
    address:''
  };
  
  admin:boolean =false;
  email:boolean =false;
  
  facebook: boolean = false;
  youtube: boolean = false;
  linkedin: boolean = false;
  twitter: boolean = false;


  constructor(public router: Router,
    private activatedRoute: ActivatedRoute,
    private database: AngularFireDatabase,
    private storageService: StorageService,
    private projectService: ProjectService,
    
  )
   { 

    this.iconUrl = '../../assets/img/markers/blue-dot.png'

    }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
  ngAfterViewInit() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }



  ngOnInit() {


    this.markerPosition = [];
    // this.storageService.addItem("projectid",projectid)
    this.subscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        let userid = this.storageService.getItem('userid');
        this.projectService.getProject(param['profileId'])
        

          .subscribe(
          res => {
            this.project = res;
            {
         
            this.list=this.project['projectDescription']
            this.descriptionlength = this.list.length;
            //alert("desc length...."+length)
            //alert(this.list)
            this.descriptiondata = this.list.slice(0,260); 
           // alert(this.lessdata);

          
              //alert(this.project['projectDescription'])
              // this.startPage = 0;
              // this.paginationLimit = 1;
             }
           
            //alert(res)
        
            if(this.project['name'] === undefined ){
              this.router.navigateByUrl("/projectnotfound")
            }
            if(this.project['interventionmechanisms'] === undefined){
              this.project['interventionmechanisms']=[];
            }
            if(this.project['partnerOrganizations'] === undefined){
              this.project['partnerOrganizations']=[];
            }
            if(this.project['leads'] === undefined){
              this.project['leads']=[];
            }
            if (this.project['projectcoverPhoto'])
            this.coverBackground = " url(" + this.project['projectcoverPhoto']['url'] + ")  center center ";
           
            var obj = {
              lat: this.project['latitude'],
              lng: this.project['longitude'],
              address:this.project['projectAddress'],
              name:this.project['name'],
              iconUrl:'../../assets/img/markers/blue-dot.png',
              display:true           
            }
            this.markerPosition.push(obj)
            //this.project['projectComplete']=this.project['spent']/this.project['budget']*100;
            this.complete = res.spent / res.budget * 100;
            //alert(this.complete);
            this.admin = (res.createdBy === userid);
            this.email = false;
             this.email = (res.leads && res.leads[0] &&res.leads[0].leadEmail !== undefined && res.leads[0].leadEmail != '' )
            //this.email = (res.leads[0].email !== undefined && res.leads[0].email != '' )
            this.facebook = (res.projectFacebook !== undefined && res.projectFacebook != '')
            this.twitter = (res.projectTwitter !== undefined && res.projectTwitter != '')
            this.youtube = (res.projectYoutube !== undefined && res.projectYoutube != '')
            this.linkedin = (res.projectLinkedin !== undefined && res.projectLinkedin != '')
            this.lat = +res.latitude;
            this.long = +res.longitude;
            this.address = res.projectAddress;
            console.log('This is the lat ' + this.lat)
            //const position = new google.maps.LatLng(this.lat, this.long);
            if (isNaN(this.lat)|| this.lat == undefined || this.lat == "") {
              this.errorMessage = 'Project Address not resolved on Map. Please edit and save.';
              console.log('This is the lats and lngs 2 ' + res.address + ' ' + this.long)
              this.address = '';
            } else {
              this.lat = +(res.latitude);
              this.long = +(res.longitude);
              this.address = res.projectAddress
            }
          },


          err => {
            console.error(err);
          }


          );
        
      }
    );
  }



  editproject(projectid) {
    this.router.navigate(["/registerproject/edit/" + projectid]);
  }
  goBack(orgId) {
    this.router.navigate(["/org/" + orgId]);
  }

  showInfoWindow(x, { target: marker }) {
    //console.log('This is the showInfoWindow ' + JSON.stringify(x))
    this.marker.name = x.name;
    this.marker.address = x.address;
  }

  hideMarkerInfo() {
    this.marker.display = !this.marker.display;
  }
  clicked() {
    console.log('The marker is clicked')
  }  

  private convertStringToNumber(value: string): number {
    return +value;
  }  



showMoreItems()
{

  this.moredata=false;
  this.lessdata=true;
  // this.paginationLimit = Number(this.paginationLimit) + 3; 
   //alert(this.paginationLimit)
   //this.paginationLimit=  this.list ;  
   this.descriptiondata=  this.project['projectDescription'];
   //this.lessdata = this.moredata;  
   //alert(this.lessdata)
}
showLessItems()
{
  this.lessdata=false;
  this.moredata=true;
  //this.paginationLimit = Number(this.paginationLimit) - 3;
  this.list=this.project['projectDescription']
 
  this.descriptiondata = this.list.slice(0,260); 
  //alert(this.lessdata)

}

}





// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/project-profile/project-profile.component.ts